import { LinkWithArrow } from "components";
import { useSearchParameter } from "hooks";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Loader, Modal, PersonInfo, TableItemStatus } from "ui";

import { useTransactionById } from "../../../apis";
import {
  TRANSACTIONS_STATUSES_LIST,
  TRANSACTION_ID_SEARCH_PARAMETER
} from "../../../constants";
import { TransactionMainDetails } from "./atoms";
import { AddExpenseModalProps } from "./TransactionDetailsModal.types";

import styles from "./TransactionDetailsModal.module.scss";

const TransactionDetailsModal = ({ isOpen, onClose }: AddExpenseModalProps) => {
  const { t } = useTranslation();
  const [transactionId] = useSearchParameter(TRANSACTION_ID_SEARCH_PARAMETER);

  const { transaction, isLoading } = useTransactionById(transactionId);

  return (
    <Modal
      isOpen={isOpen}
      footer={<></>}
      title={t("Transaction Details")}
      onClose={onClose}
      className={styles.modal}
      contentClassName={styles.modal__transaction}
    >
      {isLoading && <Loader />}
      {transaction && (
        <>
          <div className={styles["modal__transaction--header"]}>
            <TableItemStatus
              statusesList={TRANSACTIONS_STATUSES_LIST}
              activeStatusIndex={TRANSACTIONS_STATUSES_LIST.findIndex(
                (statusItem) => statusItem?.value === transaction.status
              )}
            />

            <p>
              {moment(transaction.createdAt).format("DD MMMM, YYYY")} {t("at")}{" "}
              {moment(transaction.createdAt).format("HH:mm")}
            </p>
          </div>
          <div className={styles["modal__transaction--details"]}>
            <TransactionMainDetails transaction={transaction} />

            <div className={styles["modal__transaction--reseller"]}>
              <p className={styles["modal__transaction--reseller-title"]}>
                {t("Reseller")}
              </p>
              <PersonInfo
                personName={`${transaction.reseller.firstname} ${transaction.reseller.lastname}`}
                image={{ url: transaction.reseller.image?.url }}
                dimensions={{ width: 30, height: 30, borderRadius: "50%" }}
                nameClassName={styles["modal__transaction--reseller-name"]}
              >
                <LinkWithArrow
                  className={styles["modal__transaction--reseller-link"]}
                  to={{
                    pathname: `/users/all/${transaction.reseller.id}/transactions`,
                    search: ""
                  }}
                  text="Show Reseller"
                />
              </PersonInfo>
            </div>

            {transaction.driver && (
              <div className={styles["modal__transaction--driver"]}>
                <p className={styles["modal__transaction--driver-title"]}>
                  {t("Driver")}
                </p>
                <PersonInfo
                  personName={`${transaction.driver.firstname} ${transaction.driver.lastname}`}
                  image={{ url: transaction.driver.image.url }}
                  dimensions={{ width: 30, height: 30, borderRadius: "50%" }}
                  nameClassName={styles["modal__transaction--driver-name"]}
                />
              </div>
            )}
          </div>
        </>
      )}
    </Modal>
  );
};

export default TransactionDetailsModal;
